// Turns what someone typed into the route parameter the app navigates to.
//
// The vehicle rules are why this is shared rather than copied: a bare number
// maps onto a different prefix depending on which block it falls in, and two
// copies of that table would drift apart without anyone noticing.
import padStart from 'lodash/padStart';
import parseInt from 'lodash/parseInt';

export default {
  methods: {
    navigateToTrain: function(trainNumber) {
      var value = String(trainNumber == null ? '' : trainNumber).trim();
      if (!value) {
        return;
      }

      var realTrainNumber;
      if (isNaN(value)) {
        realTrainNumber = value.replace(/[^0-9]/g, '');
      } else {
        realTrainNumber = value;
      }

      if (!realTrainNumber) {
        return;
      }

      this.$router.push({ name: 'train', params: { trainNumber: realTrainNumber } });
    },

    navigateToVehicle: function(vehicle) {
      var value = String(vehicle == null ? '' : vehicle).trim();
      if (!value) {
        return;
      }

      var realVehicleId;
      if (isNaN(value)) {
        realVehicleId = value;
      } else {
        if (parseInt(value) > 910000000000) {
          realVehicleId = value;
        } else if (value >= 2800 && value < 2900 || value >= 4800 && value < 5000) {
          realVehicleId = `ICD${value}`;
        } else if (value >= 4100 && value < 4200) {
          realVehicleId = `ICK${value}`;
        } else {
          realVehicleId = `ICE${padStart(value, 4, '0')}`;
        }
      }

      this.$router.push({ name: 'vehicle', params: { vehicle: realVehicleId } });
    },
  },
};
